import { useLayoutEffect } from 'react';

export default function useProtectedPageMounted() {
  useLayoutEffect(() => {
    const originalStyle = window.getComputedStyle(document.body).background;
    document.body.style.background = 'linear-gradient(0deg, #292A3A 0%, #37384D 100%) no-repeat';
    return () => {
      document.body.style.background = originalStyle;
    };
  }, []);
}
